import { render, staticRenderFns } from "./StaticNode.vue?vue&type=template&id=d52a53ce&"
import script from "./StaticNode.vue?vue&type=script&lang=js&"
export * from "./StaticNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports